"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class DashboardClient extends authenticated_client_1.AuthenticatedClient {
    create(projectId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const _a = payload, { id, createdAt, updatedAt } = _a, body = __rest(_a, ["id", "createdAt", "updatedAt"]);
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards`, body);
            return response.payload;
        });
    }
    findAll(projectId, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/dashboards` + (fields ? `?fields=${fields}` : ''));
            return response.payload;
        });
    }
    getById(projectId, id, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/dashboards/${id}` + (fields ? `?fields=${fields}` : ''));
            return response.payload;
        });
    }
    update(projectId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { id, createdAt, updatedAt } = payload, body = __rest(payload, ["id", "createdAt", "updatedAt"]);
            const response = yield this.httpPut(`/v1/projects/${projectId}/users/me/dashboards/${id}`, body);
            return response.payload;
        });
    }
    delete(projectId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v1/projects/${projectId}/users/me/dashboards/${id}`);
            return response.payload;
        });
    }
    markAsSeen(projectId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`v2/projects/${projectId}/users/me/dashboards/${id}/mark-as-seen`);
            return response.payload;
        });
    }
    export(projectId, id, type, paperSize, context, selectedContexts) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = {
                paperSize,
                context,
                selectedContexts: selectedContexts && selectedContexts.length !== 0 ? selectedContexts : undefined,
            };
            const response = yield this.executeRaw('post', `/v1/projects/${projectId}/users/me/dashboards/${id}/export/${type}`, body);
            return {
                buffer: response.data,
                filename: DashboardClient.getFileNameFromContentDisposition(response.headers['content-disposition']),
                contentType: response.headers['content-type'],
            };
        });
    }
    share(projectId, id, message, userIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { message, userIds };
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards/${id}/share`, body);
            return response.payload;
        });
    }
    undoShare(projectId, id, dashboards) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { dashboards };
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards/${id}/undo-share`, body);
            return response.payload;
        });
    }
    findAllShared(projectId, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/dashboards-shared` + (fields ? `?fields=${fields}` : ''));
            return response.payload;
        });
    }
    deleteShared(projectId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v1/projects/${projectId}/users/me/dashboards-shared/${id}`);
            return response.payload;
        });
    }
    acceptShared(projectId, dashboardIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { dashboardSharedIds: dashboardIds };
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards-shared/accept`, body);
            return response.payload;
        });
    }
    undoDeleteShare(projectId, dashboardShared) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/dashboards-shared/undo-delete-share`, dashboardShared);
            return response.payload;
        });
    }
    countShared(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.findAllShared(projectId, 'id');
            return result.length;
        });
    }
    uploadCustomWidgetThumbnail(projectId, formData, progress$) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/users/me/widget/custom-thumbnail`, formData, {
                onUploadProgress: (progressEvent) => {
                    progress$.next(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                },
            });
            return response.payload;
        });
    }
    static getFileNameFromContentDisposition(contentDisposition) {
        if (!contentDisposition)
            return '';
        const match = contentDisposition.match(/filename[^;=\n]*=(?:(['"])(.*?)\1|[^;\n]*)/);
        if (match && match.length === 3) {
            const [_match, _quote, filename] = match;
            return filename;
        }
        return '';
    }
}
exports.DashboardClient = DashboardClient;
//# sourceMappingURL=dashboard.client.js.map